import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isWebUri } from 'valid-url';
import { fetchProjects, 
  upsertProject, 
  resetProject, 
  resetPlatformBands, 
  CREATE_PROJECT,  
  UPDATE_PROJECT } from '../../store/actions/projects/projectsActions';
import { setProjectAttachments } from '../../store/actions/projects/projectAttachments';
import { resetApprovers } from '../../store/actions/projects/projectApprovers';
import { ERROR_ALERT, toggleShowAlert } from '../../store/actions/commonActions';
import Wizard from '../../common/Wizard';
import PageTitle from '../../common/PageTitle';

import ProjectForm from './ProjectForm';
import ApprovalWorkflow from './ApprovalWorkflow';
import ProjectCosting from './ProjectCosting';
import moment from 'moment';

class ProjectWizard extends Component {

  constructor(props) {
    super(props);
    this.steps = [];
    this.project = {}
    this.actionCreate = CREATE_PROJECT;
    this.actionUpdate = UPDATE_PROJECT;
    
    this.pathname = this.props.location.pathname;
    this.pageName = this.pathname === "/projects/update" ? 'Update Project' : 'Create Project';
    this.action  = this.pathname === "/projects/update" ? UPDATE_PROJECT: CREATE_PROJECT;
  }

  componentDidMount() {
    this.props.resetPlatformBands();
    this.props.resetProject();
    this.props.resetApprovers();
    this.props.fetchProjects();
  }

  onSave = async () => {
    this.props.upsertProject(this.action, () => {
      this.props.history.push('/projects');
    }, true);
  }

  onCancel = () => {
    this.props.history.push('/projects');
  }

  setAttachments = () => {
    let projectAttachments = [];

    let attachmentNames = Array.from(document.querySelectorAll('.attachment_name'))
      .map(el => {
        return el.value;
      });
    let attachmentLinks = Array.from(document.querySelectorAll('.attachment_link'))
      .map(el => {
        return el.value;
      });

    attachmentNames.forEach((attachmentName, i) => {
      if (attachmentName && attachmentLinks[i]) {
        projectAttachments.push({
          attachment_name: attachmentName, 
          attachment_link: attachmentLinks[i]
        })
        this.props.setProjectAttachments(projectAttachments);
      }
    })
  }

  projDetailsValidation = () => {
    const project = this.props.projects.project;
    this.project = project;

    let message = "";

    const projectCodes = this.props.projects.projects
      .filter(data => data.id === project.id ? null : project)
      .map(project => project.code.toLowerCase());

    if (!Object.keys(project).length) {
      message = 'Please fill up required fields.';
    }
    else if (typeof(project.project_name) === 'undefined' || project.project_name ==='') {
      message = 'Project Name is required.';
    }
    else if (typeof(project.project_code) === 'undefined' || project.project_code === '') {
      message = 'Project Code is required.';
    }
    else if (projectCodes.includes(project.project_code.toLowerCase())) {
      message = 'Existing / duplicate Project Code, please revise.';
    }
    else if (typeof(project.client_id) === 'undefined' || project.client_id === '') {
      message = 'Client is required.';
    }
    else if (typeof(project.start_date) === 'undefined' || project.start_date === '') {
      message = 'Start Date is required.';
    }
    else if (!moment(new Date(project.start_date), "MM/DD/YYYY", true).isValid()) {
      message = 'Start Date should be a proper date.';
    }
    else if (typeof(project.end_date) === 'undefined' || project.end_date === '') {
      message = 'End Date is required.';
    }
    else if (!moment(new Date(project.end_date), "MM/DD/YYYY", true).isValid()) {
      message = 'End Date should be a proper date.';
    }
    else if (typeof(project.project_manager) === 'undefined' || project.project_manager === '') {
      message = 'MS Manager is required.';
    }
    // else if (typeof(project.project_sponsor) === 'undefined' || project.project_sponsor === '') {
    //   message = 'Project Sponsor is required.';
    // }
    else if (typeof(project.department_id) === 'undefined'|| !project.department_id === '') {
      message = 'Department is required.';
    }
    else if (typeof(project.platform) === 'undefined' || project.platform.length === 0) {
      message = 'Platform is required.';
    }
    else if ((typeof(project.total_contract_value) === 'undefined'|| !project.total_contract_value === '') && project.fully_loaded) {
      message = 'Projected Revenue is required.';
    }
    // else if (+project.total_contract_value < 1 && project.fully_loaded) {
    //   message = 'Projected Revenue should be a proper value.';
    // }

    let attachmentNames = Array.from(document.querySelectorAll('.attachment_name'))
      .map(el => {
        return el.value;
      });
    let attachmentLinks = Array.from(document.querySelectorAll('.attachment_link'))
      .map(el => {
        return el.value;
      });

    attachmentNames.forEach((attachmentName, i) => {
      if (attachmentName && attachmentLinks[i]) {
        if (!isWebUri(attachmentLinks[i])) {
          message = 'The link in attachments is invalid. It should be a valid URL.';
        }
      }
    })
    
    if (message) {
      this.props.toggleShowAlert(true, ERROR_ALERT, message);
      return false;
    }

    return true;
  }

  approversValidation = () => {
    const approvers = this.props.projects.approvers;

    if (!approvers || !approvers.length) {
      const message = "Please select approver/s."
      this.props.toggleShowAlert(true, ERROR_ALERT, message);
      return false;
    }
    return true;
  }

  projCostingValidation = () => {
    const project = this.project;
    let message = "";

    if (!project.fully_loaded_cost && project.fully_loaded) {
      message = "Please fill up the Project Costing form."
      this.props.toggleShowAlert(true, ERROR_ALERT, message);
      return false;
    }

    return true;
  }

  render() {
    return (
      <>  
        <PageTitle pageName={this.pageName} />
        <Wizard onSave={this.onSave} onCancel={this.onCancel}>
          <ProjectForm 
            inWizard={true} 
            isImported={true} 
            stepTitle="Project Details" 
            onValidate={this.projDetailsValidation} 
            onNextStep={this.setAttachments} />
          {/* <ApprovalWorkflow inWizard={true} isImported={true} stepTitle="Approvers" onValidate={this.approversValidation} /> */}
          <ProjectCosting inWizard={true} 
            action={this.action} 
            stepTitle="Project Costing Worksheet" 
            onValidate={this.projCostingValidation}
            project={this.project}
          />
        </Wizard>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  platforms: state.platforms, 
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    upsertProject: (...args) => dispatch(upsertProject(...args)),
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    resetProject:  () => dispatch(resetProject()),
    resetApprovers: () => dispatch(resetApprovers()),
    resetPlatformBands: () => dispatch(resetPlatformBands()),
    setProjectAttachments: (...args) =>  dispatch(setProjectAttachments(...args))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectWizard))
